import { render, staticRenderFns } from "./TestGenera.vue?vue&type=template&id=2158db3b&scoped=true"
import script from "./TestGenera.vue?vue&type=script&lang=js"
export * from "./TestGenera.vue?vue&type=script&lang=js"
import style0 from "./TestGenera.vue?vue&type=style&index=0&id=2158db3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158db3b",
  null
  
)

export default component.exports